export const VRP_TENANT_ID = '7bfec41f-aa3f-4602-95d2-f7996e4f0e59';

export const DEMO_TEST_PARTNER_TENANT_ID =
  '0b6a7bd6-56cc-46b5-b2ab-1bd7d1e994fa';

export const XIMPLIFI_TENANT_ID = 'd6ab2bbe-e0fc-48d9-89a3-c3c05f4e79b5';

// Hyperline coupons
export const HYPERLINE_PARTNER_TIER_10_PERCENT_COUPON_ID = 'cou_56kMhdo4fYNs7c';
export const HYPERLINE_PARTNER_TIER_20_PERCENT_COUPON_ID = 'cou_ExjGVUcu15XKeq';
export const HYPERLINE_PARTNER_TIER_30_PERCENT_COUPON_ID = 'cou_PJI6mXZHOyoWlx';
export const HYPERLINE_PARTNER_TIER_40_PERCENT_COUPON_ID = 'cou_gnYic7Uu8zHJX9';
export const HYPERLINE_PARTNER_TIER_50_PERCENT_COUPON_ID = 'cou_1saVofWCoJsVyz';
export const HYPERLINE_PARTNER_TIER_60_PERCENT_COUPON_ID = 'cou_tJI9hmHkQXjXOp';

export const HYPERLINE_PARTNER_TIER_COUPON_IDS = {
  10: HYPERLINE_PARTNER_TIER_10_PERCENT_COUPON_ID,
  20: HYPERLINE_PARTNER_TIER_20_PERCENT_COUPON_ID,
  30: HYPERLINE_PARTNER_TIER_30_PERCENT_COUPON_ID,
  40: HYPERLINE_PARTNER_TIER_40_PERCENT_COUPON_ID,
  50: HYPERLINE_PARTNER_TIER_50_PERCENT_COUPON_ID,
  60: HYPERLINE_PARTNER_TIER_60_PERCENT_COUPON_ID,
} as const;
